import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import type { MaxHeightProps, SpaceProps } from 'styled-system';
import { maxHeight, space } from 'styled-system';

import { HeadlineH6, SubtitleST3 } from 'common/components/Typography';
import { textWithEllipsis } from 'common/theme/styles';

export interface CardTextBlockProps {
  headline: Nullable<string>;
  subline: Nullable<string>;
}

const TextWrapper = styled.div<SpaceProps>`
  ${space};
`;

const Headline = styled(HeadlineH6)<MaxHeightProps>`
  ${maxHeight};
  ${textWithEllipsis(2)};
`;

const headlineStyles: ComponentProps<typeof Headline> = {
  mb: ['sp_2', null, null, 'sp_4'],
};

const sublineStyles: ComponentProps<typeof SubtitleST3> = {
  overflow: 'hidden',
  color: 'sys.neutral.border.hover',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
};

export const CardTextBlock = ({ subline, headline }: CardTextBlockProps) => (
  <TextWrapper m="sp_16">
    {headline && <Headline {...headlineStyles}>{headline}</Headline>}
    {subline && <SubtitleST3 {...sublineStyles}>{subline}</SubtitleST3>}
  </TextWrapper>
);
